interface TokenListProps {
  label: string;
  tokens: string[];
  tone: 'added' | 'removed' | 'unchanged';
}

/** Shared between the version-upload preview and the template detail page's recent-changes panel. */
export function TokenList({ label, tokens, tone }: TokenListProps) {
  if (tokens.length === 0) return null;

  const toneClass =
    tone === 'added'
      ? 'bg-emerald-50 text-emerald-900 ring-emerald-200'
      : tone === 'removed'
        ? 'bg-rose-50 text-rose-900 ring-rose-200'
        : 'bg-muted text-muted-foreground ring-border';

  return (
    <div className="flex flex-wrap items-baseline gap-2">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      {tokens.map((token) => (
        <code key={token} className={`rounded px-1.5 py-0.5 text-xs ring-1 ring-inset ${toneClass}`}>
          {token}
        </code>
      ))}
    </div>
  );
}
